import {FC} from "react";
import {BlockToggleDescriptionTehnology} from "../../InfoExpand/blockToggleDescriptionTehnology";
import {
  apiKeyDataTehnology,
  urlApi,
  urlApiDataTehnology,
} from "../../../helper/api";
import {
  IClusterDataFromServer,
  IMetricsData,
  ITehnologiesDataFromServer,
  ITehnologyDataSideBar,
} from "../../../pages/Dashboard/Dashboard.type";
import {ChartView} from "../../../types/chartView";
import {ITypeRadar} from "../../../types";
import ApplicationScenarios from "../../ApplicationScenarios";
import {OpenedDescriptionContent, Title} from "../stylesCases";
import {BlockDescription} from "../SidebarCardUI/BlockDescription";
import {TitleBlockTrend} from "../SidebarCardUI/TitleBlockTrend";
import {TitleCard} from "../styles";
import useFetchDataTechTehnologyById from "../../../hooks/useFetchDataTechTehnology";
import {MarketScienceCharts} from "../SidebarCardUI/MarketScienceCharts/MarketScienceCharts";
import {MarketScienceChartPanel} from "../SidebarCardUI/MarketScienceCharts/MarketScienceChartPanel";
import {GartnerCharts} from "../SidebarCardUI/GartnerCharts/GartnerCharts";
import {GartnerChartPanel} from "../SidebarCardUI/GartnerCharts/GartnerChartPanel";
import {ChartEntryButtonsRow} from "../SidebarCardUI/GartnerCharts/ChartEntryButton";
import {isGartnerEligibleEntity} from "../SidebarCardUI/GartnerCharts/constants";
import {Prognoz2040Section} from "../SidebarCardUI/Prognoz2040";
import {SideBarContentMapBattery} from "./SideBarContentMapBattery";

interface IProps {
  idMoleculeActive: number;
  dataCluster?: IClusterDataFromServer | undefined;
  clusterIdOnTehnologie?: number;
  dataTehnology: ITehnologiesDataFromServer | undefined;
  typeRadar: ITypeRadar;
  colorTitle?: string;
  technologieId?: number | string | null;
  setChartView?: (value: ChartView) => void;
  chartView?: ChartView;
}

export const SideBarContentMapTehnologie: FC<IProps> = ({
  dataTehnology: dataTechnology,
  typeRadar,
  colorTitle,
  technologieId,
  idMoleculeActive,
  dataCluster,
  setChartView,
  chartView = "none",
}) => {
  if (!apiKeyDataTehnology) {
    throw new Error("API key Карта технологий не тот");
  }
  const apiUrlTechTehnologie = `${urlApiDataTehnology}/api`;
  const {tehnologieData, citationList} = useFetchDataTechTehnologyById(
    apiUrlTechTehnologie,
    apiKeyDataTehnology,
    technologieId?.toString() || ""
  );
  const activeMolecule = citationList?.data?.find(
    (item) => item.id === idMoleculeActive
  );

  const activeCluster = activeMolecule?.clusters?.find(
    (item) =>
      item.cluster &&
      tehnologieData?.data.cluster &&
      item.cluster.documentId === tehnologieData?.data.cluster.documentId
  );

  const infoActiveTehnologie = activeCluster?.technologies.find(
    (item) =>
      tehnologieData?.data.cluster &&
      item.technology.documentId === tehnologieData?.data.documentId
  );

  const dataTehnology: ITehnologyDataSideBar | undefined = tehnologieData
    ? {
        id: tehnologieData.data.documentId,
        name: tehnologieData?.data?.name ?? "",
        cluster_name: tehnologieData?.data?.cluster?.name ?? "",
        desc: tehnologieData.data.desc ?? "",
        gpb: tehnologieData.data.gpb ?? false,
        growth_potential: tehnologieData.data.growth_potential ?? true,
        image: tehnologieData.data.image ?? "",
        invest_volume_tier: tehnologieData.data.invest_volume_tier || 0,
        potential_volume_tier: tehnologieData.data.potential_volume_tier || 0,
        trl: tehnologieData.data.trl_tier || 0,
        source: "",
        use_cases: tehnologieData.data.use_cases || [],
        metrics_data: tehnologieData.data.metrics_data,
        molecule_only: tehnologieData.data.molecule_only,
        is_generated_from_molecule: tehnologieData.data.is_generated_from_molecule,
        plots_data: tehnologieData.data.plots_data,
        analytics_data: tehnologieData.data.analytics_data,
        series_data: tehnologieData.data.series_data,
        prognoz_2040: tehnologieData.data.prognoz_2040,
      }
    : undefined;

  const showGartnerCharts = isGartnerEligibleEntity(dataTehnology);
  const isDataForSelectedTechnology =
    Boolean(technologieId) &&
    tehnologieData?.data?.documentId === String(technologieId);

  if (
    chartView === "gartner" &&
    showGartnerCharts &&
    isDataForSelectedTechnology &&
    dataTehnology?.plots_data &&
    dataTehnology.analytics_data
  ) {
    return (
      <GartnerChartPanel
        entityName={dataTehnology.name}
        clusterName={dataTehnology.cluster_name}
        plotsData={dataTehnology.plots_data}
        analyticsData={dataTehnology.analytics_data}
        seriesData={dataTehnology.series_data}
      />
    );
  }

  if (chartView === "marketScience" && isDataForSelectedTechnology) {
    return (
      <MarketScienceChartPanel
        dataCharts={dataTehnology?.metrics_data || ({} as IMetricsData)}
      />
    );
  }

  return (
    <>
      <TitleCard color={colorTitle}>
        {dataTehnology?.name || "Default Title"}
      </TitleCard>
      <BlockDescription
        text={dataTehnology?.desc}
        image={
          dataTehnology?.image?.url &&
          `${urlApi}/cms/techradar${dataTehnology?.image?.url}`
        }
      />

      <SideBarContentMapBattery
        type="tehnologie"
        phase={dataTehnology?.analytics_data?.phase_2025}
        metricsData={dataTehnology?.metrics_data}
        nameHints={[
          dataTehnology?.name,
          dataTehnology?.cluster_name,
          dataCluster?.name,
          dataCluster?.direction?.name,
        ]}
      />

      <ChartEntryButtonsRow>
        <MarketScienceCharts
          openCharts={() => setChartView && setChartView("marketScience")}
        />
        {showGartnerCharts && (
          <GartnerCharts
            openCharts={() => setChartView && setChartView("gartner")}
          />
        )}
      </ChartEntryButtonsRow>

      <OpenedDescriptionContent>
        <Title>СЦЕНАРИИ ПРИМЕНЕНИЯ</Title>
        {dataTehnology?.use_cases.map((item: any, index) => {
          return (
            <ApplicationScenarios
              key={index}
              text={item.use_case[0].children[0].text}
            />
          );
        })}
      </OpenedDescriptionContent>

      <Prognoz2040Section data={dataTehnology?.prognoz_2040} />

      {typeRadar === "molecula" &&
        infoActiveTehnologie?.citation &&
        infoActiveTehnologie.citationUrl && (
          <BlockToggleDescriptionTehnology
            data={infoActiveTehnologie?.citation}
            url={infoActiveTehnologie?.citationUrl}
            title={<TitleBlockTrend title="Кейс реализации продукта" />}
            typeRadar={typeRadar}
            isOpen
          />
        )}

    </>
  );
};
